export const environment = {
  production: true,
  version: "v1.0.0",
  firebaseConfig: {
    apiKey: "AIzaSyDvuWe03A-ZGkBv41P-B2Olu3p938iFRK4",
    authDomain: "lbc-spiritual-gifts.firebaseapp.com",
    projectId: "lbc-spiritual-gifts",
    storageBucket: "lbc-spiritual-gifts.firebasestorage.app",
    messagingSenderId: "637127757037",
    appId: "1:637127757037:web:645998de75207dc2a150e4",
    measurementId: "G-M0N756P1LE"
  },
  devAPI: {
    url: 'https://therock.lbcdev.org/api/',
    key: 'mYMnZKlYPgIUE89ZIeEbP9w2',
  },
  prodAPI: {
    url: 'https://therock.lancasterbaptist.org/api/',
    key: 'bhW4YbpYL70tLne6SaPvPM5q'
  }
};
